import { Badge } from '@/components/ui/badge';
import { PersonalConnection } from '@/services/personal-connections/types';

const VARIANTS: Record<
  string,
  'default' | 'secondary' | 'outline' | 'destructive'
> = {
  connected: 'default',
  pending: 'secondary',
  not_connected: 'outline',
  unavailable: 'outline',
};

/** One status vocabulary for every provider (the backend's status words). */
export const ConnectionStatusBadge = ({
  connection,
}: {
  connection: Pick<PersonalConnection, 'provider' | 'status' | 'status_label'>;
}) => (
  <Badge
    data-component='connection-status-badge'
    data-testid={`connection-status-${connection.provider}`}
    variant={VARIANTS[connection.status] ?? 'destructive'}
    className={
      connection.status === 'connected' ? 'bg-green-600 text-white' : undefined
    }
  >
    {connection.status_label}
  </Badge>
);
